import React, { useState } from 'react';
import { Modal, Form, Input, Button, InputNumber} from 'antd';
import ApiIntegration from '../../logic/logicApiIntegration';
import { ACTION_ACCOUNTS_SET_TARGET_AMOUNT } from '../../apiIntegration';


const ModalSetTargetAmount = ({ accountId, accountName }) => {
    const [form] = Form.useForm();
    const [visible, setVisible] = useState(false);
    const [ fetching, setFetching ] = useState(false);

    const toggleModal = () => {
        setVisible(!visible);
    };

    const submitAction = async () => {
        setFetching(true);
        form.validateFields().then(async values => {
            await new ApiIntegration({
                data: {
                    account_id: accountId,
                    target_amount: values.target_amount,
                    reason: values.reason
                },
                action: ACTION_ACCOUNTS_SET_TARGET_AMOUNT,
            }).call();
            form.resetFields();
            setVisible(false);
        });
        setFetching(false);
    }

    return (
        <>
            <Button onClick={toggleModal}>Set Target Amount</Button>
            <Modal
                open={visible}
                title={`Set target amount for the account,${accountName}`}
                onCancel={()=>{form.resetFields(); setVisible(false)}}
                onOk={submitAction}
                okText="Submit"
                okButtonProps={{loading: fetching, disabled: fetching}}
                cancelButtonProps={{disabled: fetching}}
            >
                <Form form={form} layout="vertical" onSubmit={submitAction}>
                    <Form.Item
                        name="target_amount"
                        label="New Target Amount"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter the target amount',
                            },
                        ]}
                    >
                        <InputNumber
                            defaultValue={1000}
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            style={{width: '100%'}}
                            />
                    </Form.Item>

                    <Form.Item
                        name="reason"
                        label="Reason"
                        rules={[
                            {
                                required: true,
                                message: 'Please enter the reason for setting the new target amount',
                            },
                        ]}
                    >
                        <Input.TextArea rows={3}/>
                    </Form.Item>

                </Form>
            </Modal>
        </>
    );
};

export default ModalSetTargetAmount;
